<section class="flat-education s3 position-relative" id="resume">
    <div class="container">
      <div class="flat-title t2 animate-element wow delay5 fadeInDown" data-wow-delay="0.5s">
        <h4 class="sub-title mg-b13">Educational qualification</h4>
        <h2 class="title-section color-d11">Education & Experience</h2>
      </div>
      <div class="animate-element delay5 fadeInDown" data-wow-delay="0.5s">
        <div class="padding-bottom">
          <div class="row">
            <div class="col-lg-4 last-col animate-element wow delay5 fadeIn" data-wow-delay="0.3s">
              <div class="experience-box experience-box-line t3">
                <div class="box-inner">
                  <h3 class="f-info bg-s2 color-d6">Professional bachelor's degree in
                    informatics</h3>
                  <div class="exp-wrap">
                    <div class="s-info color-d11 mg-b11">2017 - 2019</div>
                    <p class="color-d13">
                      Colegio Gregorio Hernández
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4 last-col animate-element wow delay5 fadeIn" data-wow-delay="0.3s">
              <div class="experience-box experience-box-line t3">
                <div class="box-inner">
                  <h3 class="f-info bg-s2 color-d6">GNU Certified System Administrator</h3>
                  <div class="exp-wrap">
                    <div class="s-info color-d11 mg-b11">2020</div>
                    <p class="color-d13">
                      Academia Código Libre Dominicano
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4 last-col animate-element wow delay5 fadeIn" data-wow-delay="0.5s">
              <div class="experience-box experience-box-line t3">
                <div class="box-inner">
                  <h3 class="f-info bg-s2 color-d6">Certified ORACLE SQL</h3>
                  <div class="exp-wrap">
                    <div class="s-info color-d11 mg-b11">2020</div>
                    <p class="color-d13">
                      Academia Código Libre Dominicano
                    </p>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 last-col animate-element wow delay5 fadeIn" data-wow-delay="0.8s">
            <div class="experience-box experience-box-line t3">
              <div class="box-inner">
                <h3 class="f-info bg-s2 color-d6">Udemy's Angular course </h3>
                <div class="exp-wrap">
                  <div class="s-info color-d11 mg-b11">2021
                  </div>
                  <p class="color-d13">
                    Angular beginners to advance with Fernando Herrera.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 last-col animate-element wow delay5 fadeIn" data-wow-delay="1s">
            <div class="experience-box experience-box-line t3">
              <div class="box-inner">
                <h3 class="f-info bg-s2 color-d6">PluralSight's C# certifications</h3>
                <div class="exp-wrap">
                  <div class="s-info color-d11 mg-b11">2021</div>
                  <p class="color-d13">
                    C# Fundamentals, ASP.NET Core Fundamentals,
                    LINQ Fundamentals, Testing .NET Code with xUnit.net : Getting Started.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 last-col animate-element wow delay5 fadeIn" data-wow-delay="1.2s">
            <div class="experience-box t3">
              <div class="box-inner">
                <h3 class="f-info bg-s2 color-d6">Software Development

                </h3>
                <div class="exp-wrap">
                  <div class="s-info color-d11 mg-b11">2019 - 2022
                    <p class="color-d13">
                      (Tecnología en Desarrollo de Software at ITLA)
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>